import { DownloadableAssetFile } from "@themes/pollinator/ui/DownloadableAssetFile";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { WorkbookData } from "@platform/types/dashboard.types";

export type Props = {
  data?: WorkbookData;
  /** Callback when a download button is clicked */
  onDownload?: () => void;
};

export function ProgramWorkbookDownload({ data, onDownload }: Props) {
  if (!data) return null;

  return (
    <SectionHeading
      title="Pollinator Workbook"
      description="Download the workbook for the 2025 cycle."
      className="mb-16 w-full max-w-3xl"
    >
      <div className="w-full max-w-3xl">
        <DownloadableAssetFile
          file={data?.file || { name: "", type: "", size: "", downloadUrl: "" }}
          onClick={onDownload}
        />
      </div>
    </SectionHeading>
  );
}

export default ProgramWorkbookDownload;

